export default function truncate (text: string, stop: number, clamp = '...'): string {
  if (!text) return '' // Handle null/undefined/empty text

  return text.length > stop
    ? text.slice(0, stop) + clamp
    : text // Return the original text if it's within the limit
}
